export const categories = [
  { slug: 'dongzuo', name: '动作游戏', icon: 'ri-gamepad-line', description: '紧张刺激的动作体验，考验反应与操作技巧' },
  { slug: 'jiaose-banyan', name: '角色扮演', icon: 'ri-user-star-line', description: '沉浸式剧情，塑造属于你的传奇角色' },
  { slug: 'celve', name: '策略游戏', icon: 'ri-lightbulb-line', description: '运筹帷幄，智慧与谋略的终极对决' },
  { slug: 'xiuxian', name: '休闲游戏', icon: 'ri-cup-line', description: '轻松上手，随时随地享受游戏乐趣' },
  { slug: 'tiyu', name: '体育竞技', icon: 'ri-basketball-line', description: '真实赛场体验，点燃竞技热血' },
  { slug: 'qipai', name: '棋牌游戏', icon: 'ri-stack-line', description: '经典棋牌玩法，策略与运气的结合' },
];

export const games = [
  {
    id: 1,
    slug: 'dragon-quest-x',
    name: '龙之探险X',
    category: 'dongzuo',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20dragon%20adventure%20game%20scene%20with%20warrior%20character%20in%20ancient%20ruins%2C%20dramatic%20lighting%2C%20cinematic%20game%20art%20style%2C%20warm%20golden%20tones%2C%20high%20detail%2C%20professional%20game%20promotional%20art&width=600&height=400&seq=game-dragon-quest&orientation=landscape',
    description: '踏上史诗般的冒险旅程，探索神秘的龙之国度，体验最纯正的动作RPG游戏。',
    rating: 4.8,
    players: '120万+',
    isHot: true,
  },
  {
    id: 2,
    slug: 'speed-racing-pro',
    name: '极速飞车Pro',
    category: 'tiyu',
    image: 'https://readdy.ai/api/search-image?query=Professional%20racing%20game%20scene%20with%20sports%20car%20on%20city%20track%20at%20sunset%2C%20motion%20blur%20effect%2C%20cinematic%20lighting%2C%20warm%20orange%20and%20gold%20tones%2C%20high%20detail%20game%20art&width=600&height=400&seq=game-speed-racing&orientation=landscape',
    description: '真实物理引擎打造极致竞速体验，多款顶级跑车任你驾驭。',
    rating: 4.6,
    players: '85万+',
    isHot: true,
  },
  {
    id: 3,
    slug: 'magic-realm-online',
    name: '魔法之境OL',
    category: 'jiaose-banyan',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20magic%20online%20game%20scene%20with%20wizard%20casting%20spells%20in%20enchanted%20forest%2C%20magical%20glow%20effects%2C%20warm%20mystical%20atmosphere%2C%20cinematic%20game%20art%20style&width=600&height=400&seq=game-magic-realm&orientation=landscape',
    description: '宏大的魔幻世界，自由捏脸、多职业选择，开启你的魔法冒险。',
    rating: 4.9,
    players: '200万+',
    isHot: true,
  },
  {
    id: 4,
    slug: 'war-strategy-king',
    name: '战争策略王',
    category: 'celve',
    image: 'https://readdy.ai/api/search-image?query=Medieval%20strategy%20war%20game%20scene%20with%20castle%20and%20army%20formation%20on%20battlefield%2C%20epic%20scale%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20game%20art&width=600&height=400&seq=game-war-strategy&orientation=landscape',
    description: '指挥千军万马，建设城池帝国，用智慧征服每一寸土地。',
    rating: 4.5,
    players: '65万+',
    isHot: false,
  },
  {
    id: 5,
    slug: 'happy-farm-life',
    name: '欢乐农场记',
    category: 'xiuxian',
    image: 'https://readdy.ai/api/search-image?query=Cute%20casual%20farming%20simulation%20game%20scene%20with%20colorful%20crops%20and%20animals%2C%20bright%20sunny%20day%2C%20warm%20cheerful%20atmosphere%2C%20game%20illustration%20style&width=600&height=400&seq=game-happy-farm&orientation=landscape',
    description: '回归田园，种植收获，与好友一起打造梦想中的农场天堂。',
    rating: 4.3,
    players: '50万+',
    isHot: false,
  },
  {
    id: 6,
    slug: 'poker-master-elite',
    name: '扑克大师精英',
    category: 'qipai',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20poker%20card%20game%20scene%20with%20playing%20cards%20on%20green%20felt%20table%2C%20warm%20ambient%20lighting%2C%20luxurious%20casino%20atmosphere%2C%20professional%20game%20art&width=600&height=400&seq=game-poker-master&orientation=landscape',
    description: '全球玩家实时对战，经典德州扑克玩法，考验你的心理与技巧。',
    rating: 4.7,
    players: '95万+',
    isHot: true,
  },
  {
    id: 7,
    slug: 'shadow-assassin',
    name: '暗影刺客传',
    category: 'dongzuo',
    image: 'https://readdy.ai/api/search-image?query=Stealth%20action%20game%20scene%20with%20ninja%20assassin%20on%20rooftop%20at%20night%2C%20moon%20light%2C%20dramatic%20shadows%2C%20warm%20ambient%20city%20lights%2C%20cinematic%20game%20art&width=600&height=400&seq=game-shadow-assassin&orientation=landscape',
    description: '化身暗影中的刺客，在开放世界中执行惊险的暗杀任务。',
    rating: 4.4,
    players: '72万+',
    isHot: false,
  },
  {
    id: 8,
    slug: 'basketball-king',
    name: '篮球王者',
    category: 'tiyu',
    image: 'https://readdy.ai/api/search-image?query=Intense%20basketball%20game%20scene%20with%20player%20dunking%20in%20stadium%2C%20dramatic%20arena%20lighting%2C%20warm%20golden%20highlight%20effects%2C%20sports%20game%20art%20style&width=600&height=400&seq=game-basketball-king&orientation=landscape',
    description: '真实NBA级别篮球体验，组建你的梦之队，称霸球场。',
    rating: 4.6,
    players: '110万+',
    isHot: false,
  },
  {
    id: 9,
    slug: 'myth-legend-rpg',
    name: '神话传说RPG',
    category: 'jiaose-banyan',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20RPG%20game%20scene%20with%20ancient%20temple%20and%20hero%20character%2C%20floating%20magical%20elements%2C%20warm%20mystical%20golden%20light%2C%20cinematic%20game%20art&width=600&height=400&seq=game-myth-legend&orientation=landscape',
    description: '东方神话背景的史诗RPG，探索上古传说，解锁隐藏神器。',
    rating: 4.7,
    players: '88万+',
    isHot: false,
  },
  {
    id: 10,
    slug: 'chess-master-online',
    name: '象棋大师在线',
    category: 'qipai',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20chess%20game%20scene%20with%20wooden%20chessboard%20and%20pieces%2C%20warm%20tea%20room%20atmosphere%2C%20soft%20natural%20light%2C%20elegant%20game%20art&width=600&height=400&seq=game-chess-master&orientation=landscape',
    description: '经典中国象棋，智能匹配对手，从新手到大师的进阶之路。',
    rating: 4.5,
    players: '60万+',
    isHot: false,
  },
  {
    id: 11,
    slug: 'ocean-fishing-fun',
    name: '海洋垂钓乐',
    category: 'xiuxian',
    image: 'https://readdy.ai/api/search-image?query=Relaxing%20ocean%20fishing%20casual%20game%20scene%20with%20fishing%20boat%20on%20calm%20sea%20at%20sunset%2C%20warm%20golden%20light%20reflecting%20on%20water%2C%20peaceful%20game%20art&width=600&height=400&seq=game-ocean-fishing&orientation=landscape',
    description: '悠闲的海上垂钓体验，收集稀有鱼种，与朋友比拼钓技。',
    rating: 4.2,
    players: '35万+',
    isHot: false,
  },
  {
    id: 12,
    slug: 'empire-building-pro',
    name: '帝国建设者Pro',
    category: 'celve',
    image: 'https://readdy.ai/api/search-image?query=City%20building%20strategy%20game%20scene%20with%20ancient%20civilization%20and%20wonders%2C%20birds%20eye%20view%2C%20warm%20sunset%20lighting%2C%20cinematic%20game%20art&width=600&height=400&seq=game-empire-building&orientation=landscape',
    description: '从零开始建造属于你的帝国，发展科技、贸易与军事力量。',
    rating: 4.8,
    players: '150万+',
    isHot: true,
  },
];

export const articles = [
  {
    id: 1,
    slug: 'pg-guanwang-xinshou-zhinan',
    title: 'PG官网新手入门指南：从注册到畅玩全攻略',
    excerpt: '本文详细介绍PG官网的注册流程、账号安全设置以及游戏下载安装步骤，帮助新手玩家快速上手，享受安全可靠的游戏体验。',
    content: `<p>欢迎来到PG官网！作为新玩家，你可能对如何开始游戏之旅感到困惑。别担心，这篇指南将带你一步步完成从注册到畅玩的全过程。</p>
<h2>一、PG官网账号注册流程</h2>
<p>注册PG官网账号非常简单，只需几个步骤即可完成。首先访问PG官网首页，点击右上角的"注册"按钮。进入注册页面后，你需要填写以下信息：</p>
<ul><li>手机号码：用于接收验证码和账号安全验证</li><li>设置密码：建议使用字母、数字和特殊字符的组合</li><li>验证码：输入手机收到的短信验证码</li></ul>
<p>完成以上步骤后，点击"立即注册"，你的PG官网账号就创建成功了。记得妥善保管账号信息，不要与他人分享。</p>
<h2>二、账号安全设置</h2>
<p>注册完成后，强烈建议立即完善账号安全设置，确保游戏资产安全。PG官网提供了多重安全保护措施，包括实名认证、绑定邮箱、设置密保问题等。完成这些设置后，你的账号安全等级将大幅提升。</p>
<h2>三、游戏下载与安装</h2>
<p>PG官网提供多种游戏下载方式。你可以通过官网直接下载游戏客户端，也可以在移动端应用商店搜索PG游戏进行下载。下载完成后，使用刚注册的账号登录即可开始游戏。</p>
<h2>四、客服支持</h2>
<p>如果在注册或游戏过程中遇到任何问题，PG官网提供7×24小时在线客服支持。你可以通过官网的在线客服入口、官方邮箱或客服热线联系我们的专业团队。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20gaming%20website%20registration%20guide%20with%20laptop%20displaying%20game%20interface%2C%20clean%20warm%20workspace%20setting%2C%20professional%20illustration%20style&width=800&height=450&seq=article-beginner-guide&orientation=landscape',
    category: '指南教程',
    date: '2026-08-08',
    readTime: '8分钟',
    author: 'PG官方编辑',
  },
  {
    id: 2,
    slug: 'pg-guanwang-zuixin-youhui',
    title: 'PG官网最新优惠活动大盘点：超值福利不容错过',
    excerpt: 'PG官网近期推出了一系列超值优惠活动，包括新玩家首充礼包、老玩家回归奖励、节日限定活动等，本文为你详细盘点。',
    content: `<p>PG官网始终坚持为玩家提供最优质的游戏体验，同时也准备了丰富的优惠活动回馈广大玩家的支持。下面为大家盘点当前正在进行的热门活动。</p>
<h2>一、新玩家专属首充礼包</h2>
<p>首次在PG官网充值的玩家，可享受超值首充礼包。充值任意金额即可获得额外赠送的游戏道具、金币和经验加成道具，助你快速起步。</p>
<h2>二、老玩家回归奖励</h2>
<p>如果你已经有一段时间没有登录PG官网，现在回归即可领取专属回归大礼包。回归奖励包括海量游戏币、限定皮肤和专属称号，让你重回游戏巅峰。</p>
<h2>三、节日限定活动</h2>
<p>PG官网每逢重要节日都会推出限定活动。七夕、中秋、国庆等传统节日有专属任务和奖励，参与即可获得限定道具和装饰品。</p>
<h2>四、邀请好友奖励</h2>
<p>邀请好友加入PG官网，你和好友都能获得丰厚奖励。每成功邀请一位好友注册并完成新手任务，双方均可获得游戏礼包。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Exciting%20game%20promotion%20event%20with%20colorful%20gift%20boxes%20and%20gold%20coins%2C%20festive%20celebration%20atmosphere%2C%20warm%20golden%20lighting%2C%20game%20promotional%20art&width=800&height=450&seq=article-promotions&orientation=landscape',
    category: '优惠活动',
    date: '2026-08-06',
    readTime: '6分钟',
    author: 'PG官方编辑',
  },
  {
    id: 3,
    slug: 'pg-youxi-anquanxing-baozhang',
    title: 'PG官网安全性全面保障：你的游戏资产由我们守护',
    excerpt: '了解PG官网如何通过多重安全机制保护玩家账号和游戏资产，包括数据加密、反作弊系统和隐私保护措施。',
    content: `<p>在数字游戏时代，账号安全和资产保护是玩家最关心的问题之一。PG官网高度重视玩家安全，建立了全方位的安全防护体系。</p>
<h2>一、高级数据加密</h2>
<p>PG官网采用业界领先的SSL/TLS加密技术，确保玩家在登录、充值和游戏过程中的所有数据传输安全。你的个人信息和支付数据都经过严格加密，防止被截获和窃取。</p>
<h2>二、智能反作弊系统</h2>
<p>PG官网部署了先进的AI反作弊系统，能够实时监测和阻止各类作弊行为。系统通过行为分析、模式识别等技术手段，确保游戏环境的公平公正。</p>
<h2>三、双重身份验证</h2>
<p>PG官网支持双重身份验证功能。开启后，每次登录都需要输入密码和动态验证码，即使密码泄露，他人也无法登录你的账号。</p>
<h2>四、隐私保护承诺</h2>
<p>PG官网严格遵守隐私保护法规，承诺不向任何第三方出售或泄露玩家的个人信息。所有数据存储均符合国际安全标准。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20security%20and%20protection%20concept%20with%20shield%20icon%20and%20lock%2C%20warm%20professional%20atmosphere%2C%20clean%20modern%20illustration%20style&width=800&height=450&seq=article-security&orientation=landscape',
    category: '安全指南',
    date: '2026-08-03',
    readTime: '7分钟',
    author: 'PG官方编辑',
  },
  {
    id: 4,
    slug: 'pg-redian-youxi-tuijian',
    title: 'PG官网热门游戏推荐：2026年8月必玩榜单',
    excerpt: '为你精选PG官网当前最热门的十款游戏，涵盖动作、角色扮演、策略、休闲等多个类型，总有一款适合你。',
    content: `<p>PG官网游戏库不断更新，每个月都有新游戏加入。以下是2026年8月最受玩家欢迎的游戏榜单，快来看看有没有你喜欢的！</p>
<h2>一、魔法之境OL</h2>
<p>作为PG官网的旗舰MMORPG，魔法之境OL以其精美的画面、丰富的剧情和自由的玩法系统赢得了超过200万玩家的喜爱。本月新资料片"暗影崛起"上线，带来全新职业和地图。</p>
<h2>二、龙之探险X</h2>
<p>这款动作RPG以爽快的打击感和深度的装备系统著称。最新版本新增了多人副本模式，你可以与好友组队挑战强大的Boss。</p>
<h2>三、帝国建设者Pro</h2>
<p>如果你喜欢策略游戏，帝国建设者Pro绝对不容错过。从石器时代到信息时代，跨越万年文明发展，体验建造帝国的成就感。</p>
<h2>四、扑克大师精英</h2>
<p>全球95万玩家选择的棋牌竞技平台，公平匹配系统确保每局对战质量。新增锦标赛模式，赢取丰厚奖励。</p>
<h2>五、篮球王者</h2>
<p>最真实的篮球模拟游戏，拥有NBA官方授权。全新赛季模式上线，组建你的球队冲击总冠军。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Top%20popular%20games%20collage%20display%20with%20various%20game%20genres%2C%20warm%20vibrant%20colors%2C%20professional%20gaming%20showcase%20style&width=800&height=450&seq=article-top-games&orientation=landscape',
    category: '游戏推荐',
    date: '2026-08-01',
    readTime: '10分钟',
    author: 'PG官方编辑',
  },
  {
    id: 5,
    slug: 'pg-guanwang-chongzhi-jiaocheng',
    title: 'PG官网充值教程：安全便捷的支付方式详解',
    excerpt: '详细介绍PG官网支持的各种充值方式，包括支付宝、微信支付、银行卡等，以及充值过程中的注意事项。',
    content: `<p>PG官网提供多种安全便捷的充值方式，满足不同玩家的支付需求。本文详细介绍每种充值方式的步骤和注意事项。</p>
<h2>一、支持的支付方式</h2>
<p>PG官网目前支持以下支付方式：支付宝、微信支付、银联卡支付、Apple Pay（iOS设备）。所有支付渠道均经过安全认证，确保你的资金安全。</p>
<h2>二、充值步骤</h2>
<p>登录PG官网后，点击右上角的"充值"按钮，选择你需要的充值金额或自定义金额，然后选择支付方式完成支付即可。充值成功后，游戏币将即时到账。</p>
<h2>三、充值优惠</h2>
<p>PG官网经常推出充值优惠活动，如充值满减、额外赠送等。建议关注官网公告，在活动期间充值可获得更多游戏币。</p>
<h2>四、充值注意事项</h2>
<p>请务必通过PG官网官方渠道进行充值，不要相信任何第三方代充服务。如遇到充值问题，请及时联系官方客服处理。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Online%20payment%20and%20recharge%20concept%20with%20mobile%20phone%20showing%20payment%20interface%2C%20warm%20modern%20setting%2C%20clean%20professional%20illustration&width=800&height=450&seq=article-recharge&orientation=landscape',
    category: '指南教程',
    date: '2026-07-28',
    readTime: '5分钟',
    author: 'PG官方编辑',
  },
  {
    id: 6,
    slug: 'pg-shouyou-xiazai-anzhuang',
    title: 'PG手游下载安装完整教程：iOS与安卓双平台指南',
    excerpt: '无论你使用iPhone还是安卓手机，本文都将手把手教你如何下载和安装PG手游客户端，轻松开启移动游戏之旅。',
    content: `<p>PG官网不仅提供PC端游戏，也为移动端玩家准备了丰富的手机游戏。以下是iOS和安卓平台的下载安装教程。</p>
<h2>一、iOS用户下载指南</h2>
<p>iPhone用户可以直接在App Store搜索"PG游戏"进行下载。或者访问PG官网移动版，点击"iOS下载"按钮跳转到App Store页面。安装完成后，使用你的PG账号登录即可。</p>
<h2>二、安卓用户下载指南</h2>
<p>安卓用户可以通过PG官网直接下载APK安装包。访问PG官网，点击"安卓下载"按钮，下载完成后按照手机提示完成安装。首次安装可能需要开启"允许安装未知来源应用"的权限。</p>
<h2>三、安装常见问题</h2>
<p>如果安装过程中遇到问题，如安装失败、闪退等，请检查手机系统版本是否符合要求，存储空间是否充足，或尝试重新下载安装包。</p>
<h2>四、移动端特色功能</h2>
<p>PG手游针对移动端做了全面优化，支持触屏操作、离线模式和省电模式，让你随时随地享受游戏乐趣。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Mobile%20game%20download%20concept%20with%20smartphone%20displaying%20game%20interface%2C%20warm%20modern%20lifestyle%20setting%2C%20clean%20illustration%20style&width=800&height=450&seq=article-mobile-download&orientation=landscape',
    category: '指南教程',
    date: '2026-07-25',
    readTime: '6分钟',
    author: 'PG官方编辑',
  },
  {
    id: 7,
    slug: 'pg-shequ-huodong-gaizao',
    title: 'PG社区活动精彩回顾：玩家共创美好游戏记忆',
    excerpt: '回顾PG官网近期的社区活动和玩家互动，包括线上锦标赛、玩家见面会和创意工坊评选等精彩内容。',
    content: `<p>PG官网不仅是一个游戏平台，更是一个充满活力的玩家社区。让我们一起回顾近期举办的精彩社区活动。</p>
<h2>一、PG线上锦标赛</h2>
<p>上个月举办的PG线上锦标赛吸引了超过5万名玩家参与。经过两周的激烈角逐，最终决出了各个游戏项目的冠军。获奖玩家不仅获得了丰厚奖金，还获得了专属的冠军称号和限定道具。</p>
<h2>二、城市玩家见面会</h2>
<p>PG官网在北京、上海、广州、成都四个城市举办了玩家线下见面会，让玩家与开发团队面对面交流，分享游戏体验和建议。</p>
<h2>三、创意工坊评选</h2>
<p>本期创意工坊评选收到了超过1000份玩家投稿，包括游戏攻略、同人画作和创意视频。经社区投票选出的优秀作品已在官网展示。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Gaming%20community%20event%20with%20players%20celebrating%20together%2C%20warm%20festive%20atmosphere%2C%20colorful%20lights%2C%20game%20community%20art&width=800&height=450&seq=article-community&orientation=landscape',
    category: '社区动态',
    date: '2026-07-20',
    readTime: '5分钟',
    author: 'PG官方编辑',
  },
  {
    id: 8,
    slug: 'pg-gengxin-ribao-0809',
    title: 'PG官网更新日报：新版本内容与系统优化一览',
    excerpt: 'PG官网本周进行了多项重要更新，包括游戏性能优化、新功能上线和Bug修复，本文为你详细解读每项更新内容。',
    content: `<p>PG官网始终保持高频更新，为玩家带来最佳游戏体验。以下是本周（8月4日-8月9日）的更新内容汇总。</p>
<h2>一、性能优化</h2>
<p>本周我们对游戏引擎进行了全面优化，降低了内存占用，提升了帧率稳定性。特别是在中低端设备上，游戏流畅度提升了30%以上。</p>
<h2>二、新功能上线</h2>
<p>新增"战队系统"，玩家可以创建或加入战队，与队友一起参与战队任务和联赛。此外，好友列表新增"最近队友"功能，方便添加游戏中的伙伴。</p>
<h2>三、Bug修复</h2>
<p>修复了部分设备上登录界面卡顿的问题；修复了充值页面偶尔跳转错误的问题；优化了游戏内聊天系统的消息同步速度。</p>
<h2>四、下周预告</h2>
<p>下周将会上线全新的限时活动"夏日狂欢季"，参与即可获得限定夏日皮肤和大量游戏道具，敬请期待！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Game%20update%20and%20patch%20notes%20concept%20with%20digital%20interface%20elements%2C%20warm%20modern%20tech%20atmosphere%2C%20clean%20illustration&width=800&height=450&seq=article-update-log&orientation=landscape',
    category: '更新公告',
    date: '2026-08-09',
    readTime: '4分钟',
    author: 'PG官方编辑',
  },
];

export const faqs = [
  {
    question: 'PG官网是什么？',
    answer: 'PG官网是PG游戏的官方正版平台，提供游戏下载、账号注册、安全登录、游戏资讯及客服支持等一站式服务。PG官网致力于为玩家提供安全、稳定、优质的游戏体验，是玩家获取正版游戏资源最权威的渠道。',
  },
  {
    question: '如何在PG官网注册账号？',
    answer: '访问PG官网首页，点击右上角"注册"按钮，填写手机号码、设置密码并输入短信验证码即可完成注册。注册后建议立即完成实名认证和绑定邮箱，以增强账号安全性。注册过程完全免费，无需任何费用。',
  },
  {
    question: 'PG官网有哪些游戏类型？',
    answer: 'PG官网游戏种类丰富，涵盖动作游戏、角色扮演、策略游戏、休闲游戏、体育竞技和棋牌游戏等六大类别。平台持续更新游戏库，每月都有新游戏加入，满足不同玩家的喜好和需求。',
  },
  {
    question: 'PG官网充值安全吗？',
    answer: 'PG官网采用银行级别的数据加密技术，支持支付宝、微信支付、银联卡等正规支付渠道，所有交易均经过安全认证。建议玩家仅通过PG官网官方渠道进行充值，不要相信任何第三方代充服务，确保资金安全。',
  },
  {
    question: '忘记PG官网账号密码怎么办？',
    answer: '在登录页面点击"忘记密码"，输入注册时使用的手机号码，接收验证码后即可重置密码。如果手机号码已更换，请联系PG官网客服，通过身份验证后由客服协助找回账号。',
  },
  {
    question: 'PG官网的客服联系方式是什么？',
    answer: 'PG官网提供7×24小时在线客服服务。您可以通过官网右下角的在线客服图标联系客服人员，也可以发送邮件至官方客服邮箱，或在工作时间拨打客服热线。我们承诺在工作时间30分钟内响应所有咨询。',
  },
];